module.exports = "/images/vendor/flag-icon-css/flags/4x3/bm.svg?0fdefae88aaed5d7f18948b45cf3086d";